import { useAtomValue } from 'jotai';
import { bulkProvisioningFiltersAtom } from 'atoms/filters/bulk-provisioning.ts';
import { Routes } from '@/Routes.constants.ts';
import { mapBulkProvisioningFiltersToURLSearchParams } from '@/activityLog/bulkProvisioning/Filters/utils/filtersToURLSearchParamsMapper.ts';

export const useSsmProvisioningUrlFromFilters = () => {
  const filters = useAtomValue(bulkProvisioningFiltersAtom);

  return `${Routes.simProvisioning}?${mapBulkProvisioningFiltersToURLSearchParams(filters)}`;
};
